<template>
  <v-card
    v-bind="$attrs"
    :class="classes"
    class="v-card--material pa-3"
    style="border-radius: 13px;"
  >
    <div
      class="d-flex grow flex-wrap"
    >
      <v-avatar
        v-if="avatar"
        size="128"
        class="mx-auto v-card--material__avatar elevation-5"
        color="grey"
      >
        <v-img :src="avatar" />
      </v-avatar>

      <v-sheet
        :class="{
          'pa-5': !$slots.image,
        }"
        :color="color"
        :max-height="icon ? 90 : undefined"
        :width="icon ? 'auto' : '100%'"
        elevation="5"
        class="text-start v-card--material__heading"
        dark
        style="height: 64px; min-width: 48px; width: 64px; border-radius: 13px;"
      >
        <slot
          v-if="$slots.heading"
          name="heading"
        />

        <slot
          v-else-if="$slots.image"
          name="image"
        />

        <div
          v-else-if="title && !icon"
          class="mb-0 text-h6 text-typo font-weight-bold"
          v-text="title"
        />

        <v-icon
          v-else-if="icon"
          size="24"
          v-text="icon"
        />

        <div
          v-if="text"
          class="headline font-weight-thin"
          v-text="text"
        />
      </v-sheet>

      <div
        v-if="$slots['after-heading']"
        class="ml-3"
      >
        <slot name="after-heading" />
      </div>

      <div
        v-else-if="icon && title"
        class="ml-3"
      >
        <div
          class="card-title display-2 pt-2 grey--text font-weight-light"
          v-text="title"
        />
      </div>

      <v-card
        v-if="$slots.grafico"
        class="v-card--material__heading mb-n6"
        :width="'100%'"
        elevation="0"
      >
        <slot name="grafico" />
      </v-card>
    </div>

    <slot />

    <template v-if="$slots.actions">
      <v-col
        cols="12"
        class="px-0 py-2"
      >
        <v-divider />
      </v-col>
      <v-row>
        <v-col
          cols="12"
          class="py-3"
        >
          <slot name="actions" />
        </v-col>
      </v-row>
    </template>
  </v-card>
</template>

<script>
  export default {
    name: 'MaterialCard',

    props: {
      avatar: {
        type: String,
        default: '',
      },
      color: {
        type: String,
        default: 'success',
      },
      icon: {
        type: String,
        default: undefined,
      },
      image: {
        type: Boolean,
        default: false,
      },
      text: {
        type: String,
        default: '',
      },
      title: {
        type: String,
        default: '',
      },
    },

    computed: {
      classes () {
        return {
          'v-card--material--has-heading': this.hasHeading,
        }
      },
      hasHeading () {
        return Boolean(this.$slots.heading || this.title || this.icon)
      },
      hasAltHeading () {
        return Boolean(this.$slots.heading || (this.title && this.icon))
      },
    },
  }
</script>

<style lang="sass">
.v-card--material
  &__avatar
    position: relative
    top: -64px
    margin-bottom: -32px

  &__heading
    position: relative
    top: -40px
    transition: .3s ease
    z-index: 1
</style>
